/*******************************************************************************
 * Copyright (c) 2024 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

import {ModuleWithProviders, NgModule, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PspNotificationComponent} from './psp-notification.component';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {PspNotificationService} from '@shared/common-core/notification/services/psp-notification.service';
import {MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule} from '@angular/material/snack-bar';

/**
 * This module is used to export the PspNotificationComponent.
 */
@NgModule({
  declarations: [PspNotificationComponent],
  imports: [CommonModule, NzIconModule, MatSnackBarModule],
  exports: [PspNotificationComponent],
})
export class PspNotificationModule {
  constructor() {
    const parentModule = inject(PspNotificationModule, {optional: true, skipSelf: true});

    if (parentModule) {
      throw new Error(
        'PspNotificationModule is already loaded. Import it in the AppModule only'
      );
    }
  }

  /**
   * This method is used to only provide this service once, so that it can become a singleton when this module is
   * imported into a different module
   * @returns The module with the provided PspNotificationService
   */
  static forRoot(): ModuleWithProviders<PspNotificationModule> {
    return {
      ngModule: PspNotificationModule,
      providers: [
        PspNotificationService,
        {
          provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
          useValue: {
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: 'psp-notification-container',
          },
        },
      ],
    };
  }
}
